import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDesistementConfirmComponent, IDesistementConfirmReduxProps, ITarget, IVente, IConstante } from '../../types/interfaces';
import { doDT } from '../../flux/actions/venteActions';
import { getConstanteByID, getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
// import { getBanks, clearBanks } from '../../flux/actions/bankActions';

import { useAlert } from "react-alert";
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';
import { getEncModeRegl } from '../../services/misc';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBuilding, faCheckCircle, faExclamationTriangle, faFileImage, faFilePdf, faHandRock, faMoneyCheckAlt, faSpinner, faTimes, faUser, faUserPlus} from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import PDFLink, { PreviewBase64, instantPrint, instantUploadToFTP } from '../pdf/PDFLink';
import { useDropzone } from 'react-dropzone';
import { PRIVILEGE } from '../../types/privileges';
import { markPossibleDesist } from '../../flux/actions/encaissementActions';

const ConfirmVente = ({ 
  doDT,
  vente1,
  vente2,
  isAssociation1,
  isAssociation2,
  clients1,
  clients2,
  encaissements1,
  encaissements2,
  clearAll,
  selectVente1,
  selectVente2,
  addedClients1,
  addedClients2,
  duplicateClient1,
  duplicateClient2,
  totalWithdraw1,
  totalWithdraw2,
  transferToNew1,
  transferToNew2,
  changeBien1,
  changeBien2,
  selectedBien1,
  selectedBien2,
  isAssociationBien1,
  isAssociationBien2,
  selectedAssociation1,
  selectedAssociation2,
  auth
  }: IDesistementConfirmComponent) => {
  const PREVIEW = "PREVIEW", CHECK = "CHECK", CONFIRM = "CONFIRM";

  const [modal, setModal] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  const [documentModal, setDocumentModal] = useState(false);
  const [noDoc1, setNoDoc1] = useState(false);
  const [noDoc2, setNoDoc2] = useState(false);
  const [previewBase64, setPreviewBase64] = useState({file: '', fileName: ''});
  
  const [desistementPdfs1, setDesistementPdfs1] = useState<any[]>([]);
  const [desistementPdfs2, setDesistementPdfs2] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ['application/pdf', 'image/*'],
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setDesistementPdfs1(acceptedFiles);
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type PDF ou Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const { getRootProps: getRootProps2, getInputProps: getInputProps2, isDragActive: isDragActive2 } = useDropzone({
    accept: ['application/pdf', 'image/*'],
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setDesistementPdfs2(acceptedFiles);
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type PDF ou Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const [comment1Value, setComment1Value] = useState('');
  const [comment2Value, setComment2Value] = useState('');
  useEffect(() => console.log("desistementPdfs1", desistementPdfs1), [desistementPdfs1])
  
  const handleToggle = () => setModal(!modal);

  const noDoc1ChangeHandle = e => setNoDoc1(e.target.checked)
  const noDoc2ChangeHandle = e => setNoDoc2(e.target.checked)

  const alert = useAlert();

  const modalClosedHandle = () => {
    setNoDoc1(false);
    setNoDoc2(false);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const comment1ChangeHandler = (e: ITarget) => setComment1Value(e.target.value);
  const comment2ChangeHandler = (e: ITarget) => setComment2Value(e.target.value);

  const callback = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModal(false);
      clearAll();
      setComment1Value('');
      setComment2Value('');
      setDesistementPdfs1([]);
      setDesistementPdfs2([]);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Validé avec succès");

      if(success.association1Id)
        selectVente1(success.association1Id, true)
      else if(success.vente1Id)
        selectVente1(success.vente1Id, false)
      
      if(success.association2Id)
        selectVente2(success.association2Id, true)
      else if(success.vente2Id)
        selectVente2(success.vente2Id, false)

      // setPreviewBase64({file: success.file, fileName: success.fileName});
      // setDocumentModal(true);
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const confirmHandle = async (action) => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    if(!vente1 && !vente2){
      alert.error("Veuillez sélectionner un bien");
      return
    }
    const desistementsClients1 = clients1.filter(e => !!e.desiste);
    const desistementsClients2 = clients2.filter(e => !!e.desiste);
    const desistementsPClients1 = clients1.filter(e => !!e.desiste_p);
    const desistementsPClients2 = clients2.filter(e => !!e.desiste_p);
    const desistementsEncaissements1 = encaissements1.filter(e => !!e.desiste);
    const desistementsEncaissements2 = encaissements2.filter(e => !!e.desiste);
    const transfertsClients1 = clients1.filter(e => !!e.transfere);
    const transfertsClients2 = clients2.filter(e => !!e.transfere);
    const transfertsEncaissements1 = encaissements1.filter(e => !!e.transfere);
    const transfertsEncaissements2 = encaissements2.filter(e => !!e.transfere);

    // if(!desistementsClients1.length && !desistementsClients2.length && !desistementsPClients1.length && !desistementsPClients2.length && !desistementsEncaissements1.length && !desistementsEncaissements2.length && !transfertsClients1.length && !transfertsEncaissements1.length && !transfertsClients2.length && !transfertsEncaissements2.length && !changeBien1 && !changeBien2 && !transferToNew1 && !transferToNew2)
    //   return
    if((!vente1 || !vente2) && !transferToNew1 && (transfertsClients1.length || transfertsEncaissements1.length || transfertsClients2.length || transfertsEncaissements2.length)){
      alert.error("Veuillez sélectionner un bien");
      return
    }
    if((vente1 && desistementsPClients1.length && !addedClients1?.length) || (vente2 && desistementsPClients2.length && !addedClients2?.length)){
      alert.error("Veuillez ajouter au moins un client");
      return
    }
    if((vente1 && totalWithdraw1 && (((desistementsClients1.length + transfertsClients1.length) !== ((vente1?.associationPart || vente1)?.contrat_clients?.length || 0)) || ((desistementsEncaissements1.length + transfertsEncaissements1.length) !== ((vente1?.associationPart || vente1)?.contrat_encaissements?.length || 0))))
    || (vente2 && totalWithdraw2 && (((desistementsClients2.length + transfertsClients2.length) !== ((vente2?.associationPart || vente2)?.contrat_clients?.length || 0)) || ((desistementsEncaissements2.length + transfertsEncaissements2.length) !== ((vente2?.associationPart || vente2)?.contrat_encaissements?.length || 0))))){
      alert.error("Veuillez vider les clients/encaissements");
      return
    }

    if(changeBien1 || transferToNew1){
      if(!selectedBien1){
        alert.error("Veuillez sélectionner un bien");
        return
      }
      else if(isAssociationBien1){
        if(!selectedAssociation1){
          alert.error("Veuillez saisir les informations de l'association");
          return
        }
        if((selectedBien1?.division && !selectedAssociation1.selectedFloor?.id) || (!selectedBien1?.division && !selectedAssociation1?.ETAGE && selectedAssociation1?.ETAGE !== 0)){
        // if(!selectedAssociation1.selectedFloor || selectedAssociation1.ETAGE === undefined){
        // if(selectedAssociation1.ETAGE === undefined){
          alert.error("Veuillez sélectionner un étage");
          return
        }
        if(selectedAssociation1.TYPE === undefined){
          alert.error("Veuillez sélectionner le type de l'association");
          return
        }
        if(!selectedAssociation1.POURCENTAGE){
          alert.error("Veuillez saisir un pourcentage");
          return
        }
        if(!selectedAssociation1.PRIX_VENTE){
          alert.error("Veuillez saisir le prix de vente de l'association");
          return
        }
        if(selectedBien1?.division && selectedAssociation1.PRIX_VENTE < (Number(selectedAssociation1?.selectedFloor?.totalPrice || 0) * Number(selectedAssociation1?.selectedDivisionPercent?.percent || 0)) / 100){
          alert.error(`Prix de part est inférieur à ${selectedAssociation1?.selectedDivisionPercent?.percent}% du prix de l'étage (${((Number(selectedAssociation1?.selectedFloor?.totalPrice || 0) * selectedAssociation1?.selectedDivisionPercent?.percent) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)`);
          return
        }
        // if(selectedAssociation1.PRIX_VENTE < (Number(selectedAssociation1.selectedFloor?.totalPrice || 0) * selectedAssociation1.POURCENTAGE) / 100){
        //   alert.error(`Prix de part est inférieur à ${selectedAssociation1.POURCENTAGE}% du prix de l'étage (${((Number(selectedAssociation1.selectedFloor?.totalPrice || 0) * selectedAssociation1.POURCENTAGE) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)`);
        //   return
        // }
      }
    }

    if(transferToNew1){
      if(!transfertsClients1.length || !transfertsEncaissements1.length){
        alert.error("Veuillez sélectionner au moins un client/encaissement");
        return
      }
      if(transfertsClients1.length === clients1.length && transfertsEncaissements1.length === encaissements1.length){
        alert.error("Veuillez utiliser la page \"Changement de Bien\" pour les transferts complets des clients/encaissements");
        return
      }
    }

    const dtData = {
      vente1ID: vente1?.id,
      vente2ID: vente2?.id,
      association1ID: vente1?.associationPart?.id,
      association2ID: vente2?.associationPart?.id,
      vente1,
      vente2,
      association1: vente1?.associationPart,
      association2: vente2?.associationPart,
      isAssociation1: isAssociation1 ? 1 : 0,
      isAssociation2: isAssociation2 ? 1 : 0,
      duplicateClient1: duplicateClient1 ? 1 : 0,
      duplicateClient2: duplicateClient2 ? 1 : 0,
      totalWithdraw1: totalWithdraw1 ? 1 : 0,
      totalWithdraw2: totalWithdraw2 ? 1 : 0,
      transferToNew1: transferToNew1 ? 1 : 0,
      transferToNew2: transferToNew2 ? 1 : 0,
      changeBien1: changeBien1 ? 1 : 0,
      changeBien2: changeBien2 ? 1 : 0,
      selectedBien1,
      selectedBien2,
      isAssociationBien1: isAssociationBien1 ? 1 : 0,
      isAssociationBien2: isAssociationBien2 ? 1 : 0,
      selectedAssociation1,
      selectedAssociation2,
      clients1,
      clients2,
      encaissements1,
      encaissements2,
      desistementsClients1: desistementsClients1.map(({client, ...e}) => ({...e, clientId: client?.id})),
      desistementsClients2: desistementsClients2.map(({client, ...e}) => ({...e, clientId: client?.id})),
      desistementsPClients1: desistementsPClients1.map(({client, ...e}) => ({...e, clientId: client?.id})),
      desistementsPClients2: desistementsPClients2.map(({client, ...e}) => ({...e, clientId: client?.id})),
      _addedClients1: totalWithdraw1 ? [] : addedClients1,
      _addedClients2: totalWithdraw2 ? [] : addedClients2,
      addedClients1: !totalWithdraw1 && (desistementsClients1.length || desistementsPClients1.length) ? addedClients1.map(e => e.id) : [],
      addedClients2: !totalWithdraw2 && (desistementsClients2.length || desistementsPClients2.length) ? addedClients2.map(e => e.id) : [],
      desistementsEncaissements1: desistementsEncaissements1.map(({encaissement, ...e}) => ({...e, encaissementId: encaissement?.id, encaissementStatut: encaissement?.STATUT})),
      desistementsEncaissements2: desistementsEncaissements2.map(({encaissement, ...e}) => ({...e, encaissementId: encaissement?.id, encaissementStatut: encaissement?.STATUT})),
      transfertsClients1: transfertsClients1.map(e => ({id: e.id, clientId: e.client?.id})),
      transfertsClients2: transfertsClients2.map(e => ({id: e.id, clientId: e.client?.id})),
      transfertsEncaissements1: transfertsEncaissements1.map(e => ({id: e.id, encaissementId: e.encaissement?.id})),
      transfertsEncaissements2: transfertsEncaissements2.map(e => ({id: e.id, encaissementId: e.encaissement?.id})),
      comment1: comment1Value,
      comment2: comment2Value,
      userId: auth?.user && auth?.user.id ? auth?.user.id : undefined,
      userName: auth?.user && auth?.user.username ? auth?.user.username : undefined
    }
    if(action === CHECK){
      setModal(true);
      return
    }
    else if(action === CONFIRM){
      if(!noDoc1 && (changeBien1 || totalWithdraw1 || transferToNew1 || desistementsClients1.length || desistementsPClients1.length || desistementsEncaissements1.length || transfertsClients1.length || transfertsEncaissements1.length) && !desistementPdfs1?.length){
        alert.error("Veuillez sélectionner un document");
        return
      }
      if(!noDoc2 && (changeBien2 || totalWithdraw2 || transferToNew2 || desistementsClients2.length || desistementsPClients2.length || desistementsEncaissements2.length || transfertsClients2.length || transfertsEncaissements2.length) && !desistementPdfs2?.length){
        alert.error("Veuillez sélectionner un document");
        return
      }
      setDisableSubmit(true);
      
      let uploads: any[] = [],
        uploadCount = (desistementPdfs1?.length ? 1 : 0) + (desistementPdfs2?.length ? 1 : 0);

      const uploadCallback = () => {
        if(uploads.length === uploadCount)
          doDT(vente1?.id, vente2?.id, vente1?.associationPart?.id, vente2?.associationPart?.id, vente1, vente2, vente1?.associationPart, vente2?.associationPart, isAssociation1 ? 1 : 0, isAssociation2 ? 1 : 0, duplicateClient1 ? 1 : 0, duplicateClient2 ? 1 : 0, totalWithdraw1 ? 1 : 0, totalWithdraw2 ? 1 : 0, transferToNew1 ? 1 : 0, transferToNew2 ? 1 : 0, changeBien1 ? 1 : 0, changeBien2 ? 1 : 0, selectedBien1, selectedBien2, isAssociationBien1 ? 1 : 0, isAssociationBien2 ? 1 : 0, selectedAssociation1, selectedAssociation2, desistementsClients1.map(({client, ...e}) => ({...e, clientId: client?.id})), desistementsClients2.map(({client, ...e}) => ({...e, clientId: client?.id})), desistementsPClients1.map(({client, ...e}) => ({...e, clientId: client?.id})), desistementsPClients2.map(({client, ...e}) => ({...e, clientId: client?.id})), !totalWithdraw1 && (desistementsClients1.length || desistementsPClients1.length) ? addedClients1.map(e => e.id) : [], !totalWithdraw2 && (desistementsClients2.length || desistementsPClients2.length) ? addedClients2.map(e => e.id) : [], desistementsEncaissements1.map(({encaissement, ...e}) => ({...e, encaissementId: encaissement?.id, encaissementStatut: encaissement?.STATUT})), desistementsEncaissements2.map(({encaissement, ...e}) => ({...e, encaissementId: encaissement?.id, encaissementStatut: encaissement?.STATUT})), transfertsClients1.map(e => ({id: e.id, clientId: e.client?.id})), transfertsClients2.map(e => ({id: e.id, clientId: e.client?.id})), transfertsEncaissements1.map(e => ({id: e.id, encaissementId: e.encaissement?.id})), transfertsEncaissements2.map(e => ({id: e.id, encaissementId: e.encaissement?.id})), comment1Value, comment2Value, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, uploads, callback)
      }

      if(uploadCount === 0)
        uploadCallback()
      else{
        const setCodedBuffer = (blob, isPdf, venteId, associationId, isDesistement) => {
          var reader = new FileReader();
          reader.onload = function() {
            var arrayBuffer = this.result,
              codedBuffer: string = "";
            (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
                codedBuffer += String.fromCharCode(byte);
            });
            uploads.push({codedBuffer, isPdf, venteId, associationId, isDesistement});
            uploadCallback();
          }
          reader.readAsArrayBuffer(blob);
        };

        if(desistementPdfs1?.length)
          setCodedBuffer(desistementPdfs1[0], desistementPdfs1[0].type === "application/pdf" ? 1 : 0, vente1?.id, vente1?.associationPart?.id, totalWithdraw1 || clients1.filter(e => !!e.desiste || !!e.desiste_p).length || encaissements1.filter(e => !!e.desiste).length ? 1 : 0)
        if(desistementPdfs2?.length)
          setCodedBuffer(desistementPdfs2[0], desistementPdfs2[0].type === "application/pdf" ? 1 : 0, vente2?.id, vente2?.associationPart?.id, totalWithdraw2 || clients2.filter(e => !!e.desiste || !!e.desiste_p).length || encaissements2.filter(e => !!e.desiste).length ? 1 : 0)
      }

      // doDT(vente1?.id, vente2?.id, desistementsClients1.map(({client, ...e}) => ({...e, clientId: client?.id})), desistementsClients2.map(({client, ...e}) => ({...e, clientId: client?.id})), desistementsEncaissements1.map(({encaissement, ...e}) => ({...e, encaissementId: encaissement?.id})), desistementsEncaissements2.map(({encaissement, ...e}) => ({...e, encaissementId: encaissement?.id})), transfertsClients1.map(e => ({id: e.id, clientId: e.client?.id})), transfertsClients2.map(e => ({id: e.id, clientId: e.client?.id})), transfertsEncaissements1.map(e => ({id: e.id, encaissementId: e.encaissement?.id})), transfertsEncaissements2.map(e => ({id: e.id, encaissementId: e.encaissement?.id})), auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, callback)
      // addVente(isAssociation ? 1 : 0, bien, isAssociation && bien?.contrat ? bien.contrat : undefined, table_clients, encaissements, recuFile, recu_image_counter, uploads, association, selectedProjet["id"], selectedProjet["LIBELE"], numDossier, new Date(dateVente), bien.SUPERFICIE ? prixClientTemp / bien.SUPERFICIE : bien.PRIX_M, prixClientTemp, observation, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, userValue["id"], userValue["username"], remiseTotalValue ? remiseValue : (remiseValue * bien.SUPERFICIE), prixAafficherTotalValue ? prixAafficherValue : (prixAafficherValue * bien.SUPERFICIE), callback);
      return
    }
    return dtData
  }

  const markEncs = () => {
    const encIds = encaissements1.filter(e => !!e.desiste).map(e => e.encaissementId || e.encaissement?.id).filter(e => !!e)
    if(encIds.length > 0)
      markPossibleDesist(encIds)
  }

  const ClientRow = ({data: e}) => {
    return <Row className="linesConfirmationLines">
      <Col xs="12" className="fullFlexCenter"><FontAwesomeIcon icon={faUser} /><div style={{flex: 1}}>Nom: <b>{e.client?.NOM || "-"} {e.client?.PRENOM || ""}</b>&nbsp;&nbsp;CIN: <b>{e.client?.CIN || "-"}</b></div></Col>
    </Row>
  }

  const ClientPRow = ({data: e}) => {
    return <Row className="linesConfirmationLines">
      <Col xs="12" className="fullFlexCenter"><FontAwesomeIcon icon={faUserPlus} /><div style={{flex: 1}}>Nom: <b>{e.NOM || "-"} {e.PRENOM || ""}</b>&nbsp;&nbsp;CIN: <b>{e.CIN || "-"}</b></div></Col>
    </Row>
  }

  const EncaissementRow = ({data: e}) => {
    return <Row className="linesConfirmationLines">
      <Col xs="12" className="fullFlexCenter"><FontAwesomeIcon icon={faMoneyCheckAlt} /><div style={{flex: 1}}>{getEncModeRegl(e.encaissement?.MODE_REGL)} N°: <b>{e.encaissement?.REF_REGLEMENT || "-"}</b>&nbsp;&nbsp;Montant: <b>{(e.PART || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></div></Col>
    </Row>
  }
  
  return (
    <>
      <Container className="confirmDiv" fixed="down">
        <Row className="justify-content-center">
          {!!(auth?.user?.privileges?.includes(PRIVILEGE.DESISTEMENT) && auth?.user?.privileges?.includes(PRIVILEGE.TRANSFERT) && auth?.user?.privileges?.includes(PRIVILEGE.CHANGEMENT_BIEN)) && <Col xs="12" md="4">
            <FormGroup>
              <Button
                // color="info"
                className="btnA confirmBtn"
                onClick={() => confirmHandle(CHECK)}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;Vérifier</Button>
            </FormGroup>
          </Col>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.FICHE_DESISTEMENT) && <Col xs="12" md="2">
            <FormGroup>
              <PDFLink documentType={"dt"}
                download={false}
                allowPrintPreview={true}
                buttonText="Fiche Désistement"
                style={{backgroundColor: "#a1c45c", borderColor: "#a1c45c44"}}
                func={async () => confirmHandle(PREVIEW)}
                actionAfterPrint={() => markEncs()} />
            </FormGroup>
          </Col>}
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Confirmation</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            {/* <Row className="linesConfirmationRow">
              Voulez-vous vraiment valider les transferts ?
            </Row> */}
            {clients1.filter(e => !!e.transfere).length || encaissements1.filter(e => !!e.transfere).length ? <Row>
              Transféré(s)&nbsp;<i>{vente1?.associationPart ? "de" : vente1?.TYPE?.toLowerCase().includes("app") ? "de l'appartement" : vente1?.TYPE?.toLowerCase().includes("mag") ? "du magasin" : vente1?.TYPE?.toLowerCase().includes("+") ? "du lot" : (vente1?.TYPE ? ("de " + vente1.TYPE) : "-")}</i>&nbsp;<b style={{color: "orangered"}}>{vente1?.DESIGNATION || "-"}{vente1?.associationPart ? ` (${vente1.associationPart.ETAGE === "0" ? "RDC" : (vente1.associationPart.ETAGE ? `Étage ${vente1.associationPart.ETAGE}` : "-")} - ${vente1.associationPart.POURCENTAGE || "-"}%)` : ""}</b>
              &nbsp;{!transferToNew1 ? <>
                <i>{vente2?.associationPart ? "vers" : vente2?.TYPE?.toLowerCase().includes("app") ? "vers l'appartement" : vente2?.TYPE?.toLowerCase().includes("mag") ? "vers le magasin" : vente2?.TYPE?.toLowerCase().includes("+") ? "vers le lot" : (vente2?.TYPE ? ("de " + vente2.TYPE) : "-")}</i>&nbsp;<b style={{color: "green"}}>{vente2?.DESIGNATION || "-"}{vente2?.associationPart ? ` (${vente2.associationPart.ETAGE === "0" ? "RDC" : (vente2.associationPart.ETAGE ? `Étage ${vente2.associationPart.ETAGE}` : "-")} - ${vente2.associationPart.POURCENTAGE || "-"}%)` : ""}</b>
              </> : <>
                <i>{isAssociationBien1 ? "vers" : selectedBien1?.TYPE?.toLowerCase().includes("app") ? "vers l'appartement" : selectedBien1?.TYPE?.toLowerCase().includes("mag") ? "vers le magasin" : selectedBien1?.TYPE?.toLowerCase().includes("+") ? "vers le lot" : (selectedBien1?.TYPE ? ("de " + vente2.TYPE) : "-")}</i>&nbsp;<b style={{color: "green"}}>{selectedBien1?.DESIGNATION || "-"}{isAssociationBien1 && selectedAssociation1 ? ` (${selectedAssociation1.ETAGE === "0" ? "RDC" : (selectedAssociation1.ETAGE ? `Étage ${selectedAssociation1.ETAGE}` : "-")} - ${selectedAssociation1.POURCENTAGE || "-"}%)` : ""}</b>
              </>}&nbsp;:
            </Row> : null}
            {clients1.filter(e => !!e.transfere).map((e, key) => (
              <ClientRow data={e} key={key} />
            ))}
            {encaissements1.filter(e => !!e.transfere).map((e, key) => (
              <EncaissementRow data={e} key={key} />
            ))}

            {clients2.filter(e => !!e.transfere).length || encaissements2.filter(e => !!e.transfere).length ? <Row>
              Transféré(s)&nbsp;<i>{vente2?.associationPart ? "de" : vente2?.TYPE?.toLowerCase().includes("app") ? "de l'appartement" : vente2?.TYPE?.toLowerCase().includes("mag") ? "du magasin" : vente2?.TYPE?.toLowerCase().includes("+") ? "du lot" : (vente2?.TYPE ? ("de " + vente2.TYPE) : "-")}</i>&nbsp;<b style={{color: "orangered"}}>{vente2?.DESIGNATION || "-"}{vente2?.associationPart ? ` (${vente2.associationPart.ETAGE === "0" ? "RDC" : (vente2.associationPart.ETAGE ? `Étage ${vente2.associationPart.ETAGE}` : "-")} - ${vente2.associationPart.POURCENTAGE || "-"}%)` : ""}</b>
              &nbsp;<i>{vente1?.associationPart ? "vers" : vente1?.TYPE?.toLowerCase().includes("app") ? "vers l'appartement" : vente1?.TYPE?.toLowerCase().includes("mag") ? "vers le magasin" : vente1?.TYPE?.toLowerCase().includes("+") ? "vers le lot" : (vente1?.TYPE ? ("de " + vente1.TYPE) : "-")}</i>&nbsp;<b style={{color: "green"}}>{vente1?.DESIGNATION || "-"}{vente1?.associationPart ? ` (${vente1.associationPart.ETAGE === "0" ? "RDC" : (vente1.associationPart.ETAGE ? `Étage ${vente1.associationPart.ETAGE}` : "-")} - ${vente1.associationPart.POURCENTAGE || "-"}%)` : ""}</b>&nbsp;:
            </Row> : null}
            {clients2.filter(e => !!e.transfere).map((e, key) => (
              <ClientRow data={e} key={key} />
            ))}
            {encaissements2.filter(e => !!e.transfere).map((e, key) => (
              <EncaissementRow data={e} key={key} />
            ))}

            {clients1.filter(e => !!e.desiste).length || encaissements1.filter(e => !!e.desiste).length ? <Row>
              Désisté(s)&nbsp;<i>{vente1?.associationPart ? "de" : vente1?.TYPE?.toLowerCase().includes("app") ? "de l'appartement" : vente1?.TYPE?.toLowerCase().includes("mag") ? "du magasin" : vente1?.TYPE?.toLowerCase().includes("+") ? "du lot" : (vente1?.TYPE ? ("de " + vente1.TYPE) : "-")}</i>&nbsp;<b style={{color: "orangered"}}>{vente1?.DESIGNATION || "-"}</b>&nbsp;:
            </Row> : null}
            {clients1.filter(e => !!e.desiste).map((e, key) => (
              <ClientRow data={e} key={key} />
            ))}
            {encaissements1.filter(e => !!e.desiste).map((e, key) => (
              <EncaissementRow data={e} key={key} />
            ))}
            {clients1.filter(e => !!e.desiste_p).length ? <Row>
              Désisté(s) partiellement&nbsp;<i>{vente1?.associationPart ? "de" : vente1?.TYPE?.toLowerCase().includes("app") ? "de l'appartement" : vente1?.TYPE?.toLowerCase().includes("mag") ? "du magasin" : vente1?.TYPE?.toLowerCase().includes("+") ? "du lot" : (vente1?.TYPE ? ("de " + vente1.TYPE) : "-")}</i>&nbsp;<b style={{color: "orangered"}}>{vente1?.DESIGNATION || "-"}</b>&nbsp;:
            </Row> : null}
            {clients1.filter(e => !!e.desiste_p).map((e, key) => (
              <ClientRow data={e} key={key} />
            ))}
            {!totalWithdraw1 && clients1.filter(e => !!e.desiste || !!e.desiste_p).length && addedClients1.length ? <Row>
              Pour :
            </Row> : null}
            {!totalWithdraw1 && clients1.filter(e => !!e.desiste || !!e.desiste_p).length ? addedClients1.map((e, key) => (
              <ClientPRow data={e} key={key} />
            )) : null}
            {totalWithdraw1 || changeBien1 || transferToNew1 || clients1.filter(e => !!e.desiste || !!e.desiste_p || !!e.transfere).length || encaissements1.filter(e => !!e.desiste || !!e.transfere).length ? <Row>
              <Col xs="12">
                <div style={{position: "relative"}}>
                  <section>
                    <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                      <input {...getInputProps()} />
                      {desistementPdfs1?.length ? <aside className="thumbContainer">
                        <div className="thumbDelete" onClick={e => (e.stopPropagation(), setDesistementPdfs1([]))} title="Supprimer le document"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                        <div className="thumb" style={{height: "auto"}} key={desistementPdfs1[0].name}>
                          <div className="thumbInner">
                            <span className="thumbFileName"><FontAwesomeIcon icon={faFilePdf} />&nbsp;{desistementPdfs1[0].name}</span>
                          </div>
                        </div>
                      </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> <FontAwesomeIcon icon={faFilePdf} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le <span style={{fontWeight: 600}}>{totalWithdraw1 || clients1.filter(e => !!e.desiste || !!e.desiste_p).length || encaissements1.filter(e => !!e.desiste).length ? "document du désistement" : "document du transfert"}</span> ici</span>}
                    </div>
                  </section>
                  <div style={{display: "flex", justifyContent: "space-between", fontStyle: "italic", fontSize: "x-small", margin: "2px 0"}}>
                    {!desistementPdfs1?.length ? <div style={{display: "flex"}}>
                      <input type="checkbox" id="noDoc1" checked={noDoc1} onChange={noDoc1ChangeHandle} style={{marginRight: "3px"}} />
                      <Label for="noDoc1" check>Je ne dispose pas de document</Label>
                    </div> : <div></div>}
                    {clients2.filter(e => !!e.desiste || !!e.desiste_p).length || encaissements2.filter(e => !!e.desiste).length ? null : <a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a>}
                  </div>
                </div>
              </Col>
            </Row> : null}
            {changeBien1 || transferToNew1 || clients1.filter(e => !!e.desiste || !!e.desiste_p || !!e.transfere).length || encaissements1.filter(e => !!e.desiste || !!e.transfere).length ? <Row>
              <Col xs="12">
                <Input id="comment1" type="textarea" placeholder={`Commentaire (${vente1?.DESIGNATION || "-"})...`} value={comment1Value} onChange={comment1ChangeHandler} />
              </Col>
            </Row> : null}

            {clients2.filter(e => !!e.desiste).length || encaissements2.filter(e => !!e.desiste).length ? <Row>
              Désisté(s)&nbsp;<i>{vente2?.associationPart ? "de" : vente2?.TYPE?.toLowerCase().includes("app") ? "de l'appartement" : vente2?.TYPE?.toLowerCase().includes("mag") ? "du magasin" : vente2?.TYPE?.toLowerCase().includes("+") ? "du lot" : (vente2?.TYPE ? ("de " + vente2.TYPE) : "-")}</i>&nbsp;<b style={{color: "orangered"}}>{vente2?.DESIGNATION || "-"}</b>&nbsp;:
            </Row> : null}
            {clients2.filter(e => !!e.desiste).map((e, key) => (
              <ClientRow data={e} key={key} />
            ))}
            {encaissements2.filter(e => !!e.desiste).map((e, key) => (
              <EncaissementRow data={e} key={key} />
            ))}
            {clients2.filter(e => !!e.desiste_p).length ? <Row>
              Désisté(s) partiellement&nbsp;<i>{vente2?.associationPart ? "de" : vente2?.TYPE?.toLowerCase().includes("app") ? "de l'appartement" : vente2?.TYPE?.toLowerCase().includes("mag") ? "du magasin" : vente2?.TYPE?.toLowerCase().includes("+") ? "du lot" : (vente2?.TYPE ? ("de " + vente2.TYPE) : "-")}</i>&nbsp;<b style={{color: "orangered"}}>{vente2?.DESIGNATION || "-"}</b>&nbsp;:
            </Row> : null}
            {clients2.filter(e => !!e.desiste_p).map((e, key) => (
              <ClientRow data={e} key={key} />
            ))}
            {!totalWithdraw2 && clients2.filter(e => !!e.desiste || !!e.desiste_p).length && addedClients2.length ? <Row>
              Pour :
            </Row> : null}
            {!totalWithdraw2 && clients2.filter(e => !!e.desiste || !!e.desiste_p).length ? addedClients2.map((e, key) => (
              <ClientPRow data={e} key={key} />
            )) : null}
            {changeBien2 || clients2.filter(e => !!e.desiste || !!e.desiste_p || !!e.transfere).length || encaissements2.filter(e => !!e.desiste || !!e.transfere).length ? <Row>
              <Col xs="12">
                <div style={{position: "relative"}}>
                  <section>
                    <div {...getRootProps2({className: `dropzone${isDragActive2 ? " dropzoneHovered" : ""}`})}>
                      <input {...getInputProps2()} />
                      {desistementPdfs2?.length ? <aside className="thumbContainer">
                        <div className="thumbDelete" onClick={e => (e.stopPropagation(), setDesistementPdfs2([]))} title="Supprimer le document"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                        <div className="thumb" style={{height: "auto"}} key={desistementPdfs2[0].name}>
                          <div className="thumbInner">
                            <span className="thumbFileName"><FontAwesomeIcon icon={faFilePdf} />&nbsp;{desistementPdfs2[0].name}</span>
                          </div>
                        </div>
                      </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> <FontAwesomeIcon icon={faFilePdf} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le <span style={{fontWeight: 600}}>{totalWithdraw2/* || changeBien2*/ || clients2.filter(e => !!e.desiste || !!e.desiste_p).length || encaissements2.filter(e => !!e.desiste).length ? "document du désistement" : "document du transfert"}</span> ici</span>}
                    </div>
                  </section>
                  <div style={{display: "flex", justifyContent: "space-between", fontStyle: "italic", fontSize: "x-small", margin: "2px 0"}}>
                    {!desistementPdfs2?.length ? <div style={{display: "flex"}}>
                      <input type="checkbox" id="noDoc2" checked={noDoc2} onChange={noDoc2ChangeHandle} style={{marginRight: "3px"}} />
                      <Label for="noDoc2" check>Je ne dispose pas de document</Label>
                    </div> : <div></div>}
                    <a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a>
                  </div>
                  {/* <div className="bottomFloatingInputText text-right"><a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a></div> */}
                </div>
              </Col>
            </Row> : null}
            {changeBien2 || clients2.filter(e => !!e.desiste || !!e.desiste_p || !!e.transfere).length || encaissements2.filter(e => !!e.desiste || !!e.transfere).length ? <Row>
              <Col xs="12">
                <Input id="comment2" type="textarea" placeholder={`Commentaire (${vente2?.DESIGNATION || "-"})...`} value={comment2Value} onChange={comment2ChangeHandler} />
              </Col>
            </Row> : null}

            <Row className="justify-content-center">
              <Button
                className="btnA confirmBtn linesConfirmationBtn linesDeleteBtn"
                onClick={() => confirmHandle(CONFIRM)}
                disabled={disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Confirmer</Button>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <PreviewBase64 base64={previewBase64.file} fileName={previewBase64.fileName} modal={documentModal} setModal={setDocumentModal} />
      </>
  );
};

const mapStateToProps = (state: IDesistementConfirmReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { doDT })(ConfirmVente);
